module.exports = __webpack_public_path__ + "static/cgi-logo-bb9e924de79f8cf06d88a2f309a8a2ea.png";